import { ControlledTable } from "Components";
import FilterData from "Components/Filter2/Data";
import { Filter2DataProps } from "DataTypes/Common";
import { columnType, actionArrType } from "DataTypes/Table";

export const TableCol: columnType[] = [
  ControlledTable.ColumnData.PicCol("8%"),
  ControlledTable.ColumnData.PatientInfoCol("13%"),
  ControlledTable.ColumnData.PracticeCol("14%"),
  ControlledTable.ColumnData.ProviderCol("13%"),
  ControlledTable.ColumnData.PrimeInsCol("12%"),
  ControlledTable.ColumnData.SecInsCol("14%"),
  ControlledTable.ColumnData.ProgramCol("17%"),
  ControlledTable.ColumnData.ActionCol("14%"),
];

export const actionArr: (
  handleChart: () => void,
  handlePatientDetails: () => void,
  handleTask: () => void,
) => actionArrType[] = (
  handleChart,
  handlePatientDetails,
  handleTask,
) => {
    return [
      ControlledTable.ActionData.userAction(handlePatientDetails),
      ControlledTable.ActionData.chartAction(handleChart),
      ControlledTable.ActionData.taskAction(handleTask),
    ];
  };

export const FilterArr: () => Filter2DataProps[] = () => {
  const Arr: Filter2DataProps[] = [
    FilterData.patientName,
    FilterData.dob,
    FilterData.homeNo,
    FilterData.mobile,
    FilterData.language,
    FilterData.orgName,
    FilterData.orgLocation,
    FilterData.primIns,
    FilterData.secIns,
  ];
  return Arr;
};
